module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Нашими картами нельзя оплачивать сервисы с данными MCC":"Our cards cannot pay for services with these MCC data","Карты не поддерживают 3D Secure (СМС-подтверждение транзакции)":"Cards do not support 3D Secure (SMS-confirmation of transactions)"}}')
  delete Component.options._Ctor
}
